var _circle, _circle2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBronzeBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddii)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "#FF9838"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "url(#paint0_linear)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "url(#paint1_linear)",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0002,
    cy: 25,
    r: 19.76,
    fill: "#B6610B",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0002,
    cy: 25,
    r: 19.76,
    fill: "url(#paint2_linear)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0002,
    cy: 25,
    r: 19.76,
    fill: "url(#paint3_linear)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddii)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3332 11.3314C23.5912 10.8892 24.2356 10.8896 24.493 11.3321L28.0443 17.4365L31.1812 22.8286L37.8693 34.325C38.1267 34.7675 37.8043 35.3203 37.2887 35.32L30.5863 35.3156L23.8971 35.3112L18.5326 35.3077C18.0171 35.3073 17.6953 34.7542 17.9534 34.312L20.5436 29.8731C20.6634 29.6679 20.8845 29.5415 21.1238 29.5417L27.211 29.5457C27.6674 29.546 27.9722 29.1129 27.8576 28.7065C27.8428 28.6538 27.8212 28.6016 27.7916 28.5508L27.2758 27.664L24.4853 22.8675C24.244 22.4528 23.663 22.4263 23.3785 22.7886C23.3595 22.8129 23.3417 22.8389 23.3255 22.8668L22.9142 23.5715L20.2248 28.1804C20.105 28.3856 19.8838 28.512 19.6446 28.5118L14.47 28.5084C13.9545 28.508 13.6327 27.9549 13.8907 27.5128L16.6297 22.819L23.3332 11.3314Z",
    fill: "#FF9838"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3332 11.3314C23.5912 10.8892 24.2356 10.8896 24.493 11.3321L28.0443 17.4365L31.1812 22.8286L37.8693 34.325C38.1267 34.7675 37.8043 35.3203 37.2887 35.32L30.5863 35.3156L23.8971 35.3112L18.5326 35.3077C18.0171 35.3073 17.6953 34.7542 17.9534 34.312L20.5436 29.8731C20.6634 29.6679 20.8845 29.5415 21.1238 29.5417L27.211 29.5457C27.6674 29.546 27.9722 29.1129 27.8576 28.7065C27.8428 28.6538 27.8212 28.6016 27.7916 28.5508L27.2758 27.664L24.4853 22.8675C24.244 22.4528 23.663 22.4263 23.3785 22.7886C23.3595 22.8129 23.3417 22.8389 23.3255 22.8668L22.9142 23.5715L20.2248 28.1804C20.105 28.3856 19.8838 28.512 19.6446 28.5118L14.47 28.5084C13.9545 28.508 13.6327 27.9549 13.8907 27.5128L16.6297 22.819L23.3332 11.3314Z",
    fill: "url(#paint4_linear)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3332 11.3314C23.5912 10.8892 24.2356 10.8896 24.493 11.3321L28.0443 17.4365L31.1812 22.8286L37.8693 34.325C38.1267 34.7675 37.8043 35.3203 37.2887 35.32L30.5863 35.3156L23.8971 35.3112L18.5326 35.3077C18.0171 35.3073 17.6953 34.7542 17.9534 34.312L20.5436 29.8731C20.6634 29.6679 20.8845 29.5415 21.1238 29.5417L27.211 29.5457C27.6674 29.546 27.9722 29.1129 27.8576 28.7065C27.8428 28.6538 27.8212 28.6016 27.7916 28.5508L27.2758 27.664L24.4853 22.8675C24.244 22.4528 23.663 22.4263 23.3785 22.7886C23.3595 22.8129 23.3417 22.8389 23.3255 22.8668L22.9142 23.5715L20.2248 28.1804C20.105 28.3856 19.8838 28.512 19.6446 28.5118L14.47 28.5084C13.9545 28.508 13.6327 27.9549 13.8907 27.5128L16.6297 22.819L23.3332 11.3314Z",
    fill: "url(#paint5_linear)",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddii",
    x: 0.265,
    y: 0.918333,
    width: 49.47,
    height: 48.8167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.326667,
    dy: 0.326667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 0.184314 0 0 0 0 0.00784314 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.326667,
    dy: 0.326667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.5 0 0 0 0 0.185333 0 0 0 0 0.00833333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect3_innerShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.408333,
    dy: 0.326667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 0.184314 0 0 0 0 0.00784314 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_innerShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.49,
    dy: -0.0816667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 0.184314 0 0 0 0 0.00784314 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect3_innerShadow",
    result: "effect4_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i",
    x: 5.24023,
    y: 5.23999,
    width: 39.52,
    height: 39.52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.08333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 0.184314 0 0 0 0 0.00784314 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddii",
    x: 13.0648,
    y: 10.9183,
    width: 25.63,
    height: 25.1367,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.326667,
    dy: 0.326667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 0.184314 0 0 0 0 0.00784314 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.326667,
    dy: 0.326667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.5 0 0 0 0 0.185333 0 0 0 0 0.00833333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect3_innerShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.408333,
    dy: 0.326667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 0.184314 0 0 0 0 0.00784314 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_innerShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.49,
    dy: -0.0816667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 0.184314 0 0 0 0 0.00784314 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect3_innerShadow",
    result: "effect4_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.72414,
    y1: 3.58621,
    x2: 47.8621,
    y2: 45.6379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 9.30769,
    y1: 4.78947,
    x2: 43.2186,
    y2: 35.1538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C33",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED9A4E",
    stopOpacity: 0.46875
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 10.7764,
    y1: 7.3693,
    x2: 43.8233,
    y2: 41.9919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 12.0802,
    y1: 8.35999,
    x2: 40.0002,
    y2: 33.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D3008"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0D2",
    stopOpacity: 0.46875
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 17.1843,
    y1: 12.3103,
    x2: 37.5266,
    y2: 33.4824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 17.9813,
    y1: 12.92,
    x2: 35.15,
    y2: 28.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C33",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED9A4E",
    stopOpacity: 0.46875
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBronzeBadge);
export default __webpack_public_path__ + "static/media/IconBronzeBadge.bfe30c45.svg";
export { ForwardRef as ReactComponent };